module.exports = {
  colors: {
    primary: "#102A43",
    secondary: "#FADB5F",
    
    text: "#000000",
    background: "white",
    backgroundSecondary: "#243B53",

    secondaryText: "#334E68",
    primaryText: "#F0F4F8",
    tertiaryText: "#BCCCDC",
  },
  breakpoints: {
    xs: "480px",
    sm: "768px",
    md: "992px",
    lg: "1200px",
  },
  fonts: {
    primary: "Roboto, Arial, sans-serif",
  },
  borderRadius: "1rem",
  pageWidth: "62.5rem",
  headerHeight: "6.25rem",
  footerHeight: "7.5rem",
}
